import React, { useEffect, useState } from 'react'
import {useForm} from "react-hook-form";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Label, Row} from "reactstrap";


// components
import { ButtonSearch, GenericTableButton} from "../../../components/buttons/buttonsActions";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import { ActiveFormatter } from "../../../components/tables/activeFormater";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {  NO_DATA_FOUND } from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";


// actions


// services
import { scheduleService } from "../../../jwt/_services/clasificator/scheduleService";
import { typeSeasonProvider } from "../../../providers/typeSeasonProvider";
import { seasonService } from "../../../jwt/_services/clasificator/seasonService";


const ActivityScheduleList = props => {
    const { app } = props
    const  domainObject  = props.parent
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(0);
    const [listItems, setListItems] = useState([]);
    const [showLoading, setShowLoading] = useState(true);

    const [typeSeasonToday, setTypeSeasonToday] = useState(null);
    const [typeSeasonId, setTypeSeasonId] = useState(null);


    useEffect(() => {
        const dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                activity: { id: domainObject?.id }
            }
        };

        seasonService.getSeasonToday()
            .then(_typeSeasonToday => {
                if (_typeSeasonToday) {
                    setTypeSeasonToday(_typeSeasonToday);
                    setTypeSeasonId(_typeSeasonToday.id);
                    dataRequest.item.typeSeason =  { id: _typeSeasonToday.id }
                }

                refreshDataList(0, 100,dataRequest).then(_ => {});
            })
            .catch(_ => {
                refreshDataList(0, 100,dataRequest).then(_ => {});
            })
    }, []);

    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                activity: { id: domainObject?.id } ,
                typeSeason: { id: typeSeasonId }
            }
        };

        if (typeSeasonId !== null)
            dataRequest.item.typeSeason =  { id: typeSeasonId }

        refreshDataList(0, 100, dataRequest).then(_ => {})
    };

    const handleTableChange = (type, tableChangeParams) => {
        setPageSize(tableChangeParams?.page)
        setPageIndex(tableChangeParams?.sizePerPage)
    };

    const refreshDataList = async (_pageIndex, _pageSize, _filter) => {
        setShowLoading(true)

        scheduleService.search(_pageIndex, _pageSize, _filter)
            .then(result => {
                if (result){
                    setListItems(result.data)
                    setTotalSize(result?.total)
                }
        })

        setShowLoading(false)
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({ data : data, fbDataBaseId :  app?.fbDataBase?.id, remove : scheduleService.deleteItem } );
    };

    const editItem = (data) => {
        props.setShowItem(true)
        props.setItemToEdit(data)
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: `UID`,
        headerStyle: {width: '200px'},
    }, {
        dataField: 'typeSeasonName',
        text: 'Temporada',
        sort: true
    }, {
        dataField: 'time12',
        text: 'Hora (12)',
        sort: true
    }, {
        dataField: 'time24',
        text: 'Hora (24)',
        sort: true
    }, {
        dataField: 'duration',
        text: 'Duración',
        sort: true
    }, {
        dataField: 'status',
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }
    ];

    return <>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>Horarios para { domainObject?.name } { typeSeasonToday ? ' - ' + typeSeasonToday.name   : null }
            </CardTitle>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <CardBody className="">
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Tipo de temporada</Label>
                                <SelectGeneric
                                    initialValue={ typeSeasonId || typeSeasonToday?.id || null }
                                    setExternalValue={ setTypeSeasonId }
                                    provider = { typeSeasonProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="8">
                            <div className="float-right">
                                <ButtonSearch />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Form>
            <CardBody className="">
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listItems || []}
                    columns={columns}
                    noDataIndication={NO_DATA_FOUND}
                    pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    </>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    formProps : state.formProps,
})

const mapActionsToProps = ({})
export default connect(mapStateToProps, mapActionsToProps)(ActivityScheduleList)